import { useEffect, useRef, useState } from "react";
import { usd2 } from "./booking-shared";

/* ---------- Confirmation (BOOKED stamp + tear-off) ---------- */
export function Confirmation({ o, receipt }) {
  const [hit, setHit] = useState(false);
  const [torn, setTorn] = useState(false);
  const r = receipt || {};
  const flecks = useRef(Array.from({ length: 18 }, () => {
    const ang = Math.random() * Math.PI * 2, dist = 60 + Math.random() * 120;
    return { tx: Math.cos(ang) * dist, ty: Math.sin(ang) * dist - 20, r: (Math.random() * 200 - 100).toFixed(0), s: (0.5 + Math.random() * 0.9).toFixed(2), d: (Math.random() * 0.12).toFixed(2), gold: Math.random() > 0.35 };
  })).current;
  useEffect(() => {
    const a = setTimeout(() => setHit(true), 400);
    const b = setTimeout(() => setTorn(true), 1100);
    return () => { clearTimeout(a); clearTimeout(b); };
  }, []);
  return (
    <div data-testid="confirmation">
      <div className="rb-eyebrow">Confirmed</div>
      <h1 className="rb-h1">You're booked.</h1>
      <div className={`rb-card ${torn ? "torn" : ""}`} style={{ position: "relative", marginTop: 18 }} data-testid="booked-card">
        <div className={`rb-stamp ${hit ? "hit" : ""}`}>Booked</div>
        {hit && (
          <div className="rb-flecks" data-testid="booked-flecks" aria-hidden="true">
            {flecks.map((f, i) => (
              <span key={i} className={`rb-fleck ${f.gold ? "" : "ox"}`} style={{ "--tx": `${f.tx.toFixed(0)}px`, "--ty": `${f.ty.toFixed(0)}px`, "--r": `${f.r}deg`, "--s": f.s, animationDelay: `${f.d}s` }} />
            ))}
          </div>
        )}
        <div className="rb-rc-addr">{(o.address || "").split(",")[0]}</div>
        <div className="rb-rc-meta">{o.package === "all_inclusive" ? "All-Inclusive" : o.package === "a_la_carte" ? "Build your own" : "Photo Only"}{o.penthouse ? " · Penthouse Partner" : ""}</div>
        <div className="stub" />
        <div className="rb-line"><span className="lbl">Shoot date</span><span className="dots" /><span className="val">{o.shoot_date || "TBD"}</span></div>
        <div className="rb-line"><span className="lbl">Gallery by</span><span className="dots" /><span className="val">{r.delivery_date || "48 hrs"}, 4pm</span></div>
        {r.total_today != null && <div className="rb-line"><span className="lbl">Paid today</span><span className="dots" /><span className="val">{usd2(r.total_today)}</span></div>}
        {torn && <p className="rb-note" data-testid="tear-note">Save or share this card. Your producer has the details.</p>}
      </div>
      <button className="rb-btn ghost" data-testid="book-another" onClick={() => { window.top.location.href = "https://www.hub.goreelty.com/book"; }}>Book another</button>
    </div>
  );
}
